import { Box, Typography } from "@mui/material";
import loginImage from '../../assets/background/login_image.png';
import logoIcon from '../../assets/background/logo_icon.png';
import React from "react";
import imageAdmin from '../../assets/background/login_admin_login_img.jpg';



type contentAuth = {
    title: string;
    detail: string;
    content?: React.ReactNode;
    isAdmin?: boolean;
}
export const BoxContentAuth: React.FC<contentAuth> = ({ content, detail, title, isAdmin }) => {
    return (
        <Box className="m-auto w-full max-w-[956px] shadow-lg rounded-[24px] grid grid-cols-12 overflow-hidden bg-[#fff]">
            <span className="col-span-12 xl:col-span-6">
                <img className="w-full h-[25rem] md:h-full object-contain md:object-cover" src={isAdmin ? imageAdmin : loginImage} alt="loginImage" />
            </span>
            <span className="col-span-12 xl:col-span-6 px-[45px] py-[40px] flex flex-col">
                <Box className="flex justify-center gap-4 items-center">
                    <img src={logoIcon} alt="logoIcon" />
                    <Box className="flex flex-col gap-1">
                        <Typography sx={{ color: "#FCAF17" }} variant="h6">
                            วิทยาลัยพุทธศาสตร์นานาชาติ
                        </Typography>
                        <Typography sx={{ fontSize: "14px", color: '#4A4A4A' }}>
                            International Buddhist Studies College: IBSC
                        </Typography>
                    </Box>
                </Box>
                <Box mt={4} className="flex flex-col gap-2">
                    <Typography textAlign={"center"} variant="h3">
                        {title}
                    </Typography>
                    <Typography textAlign={"center"}>
                        {detail}
                    </Typography>
                </Box>
                {content}
            </span>
        </Box>
    )
}